export const APPROVE_ITEM_START = 'APPROVE_ITEM_START';
export const APPROVE_ITEM_SUCCESS = 'APPROVE_ITEM_SUCCESS';
export const APPROVE_ITEM_ERROR = 'APPROVE_ITEM_ERROR';
export const APPROVE_DISCOUNT_START = 'APPROVE_DISCOUNT_START';
export const APPROVE_DISCOUNT_SUCCESS = 'APPROVE_DISCOUNT_SUCCESS';
export const APPROVE_DISCOUNT_ERROR = 'APPROVE_DISCOUNT_ERROR';
export const CREATE_PAYLINK_START = 'CREATE_PAYLINK_START';
export const CREATE_PAYLINK_ERROR = 'CREATE_PAYLINK_ERROR';
export const DELAY_PAYMENT_START = 'DELAY_PAYMENT_START';
export const DELAY_PAYMENT_SUCCESS = 'DELAY_PAYMENT_SUCCESS';
export const DELAY_PAYMENT_ERROR = 'DELAY_PAYMENT_ERROR';
export const NEW_PAYMENT_DATA_RECEIVED = 'NEW_PAYMENT_DATA_RECEIVED';
export const SUGGEST_DISCOUNT_START = 'SUGGEST_DISCOUNT_PAYMENT_START';
export const SUGGEST_DISCOUNT_SUCCESS = 'SUGGEST_DISCOUNT_SUCCESS';
export const SUGGEST_DISCOUNT_ERROR = 'SUGGEST_DISCOUNT_PAYMENT_ERROR';



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/paymentActionTypes.js